<template>
    <div>
        <v-container fluid class="my-12">
            <v-row>
                <v-alert type="info" text class="mb-5 w-100">
                    Le paramétrage du bulletin d'adhésion ne pourra plus être modifié après le premier envoi et
                    s'appliquera aussi aux relances. <br>
                    Il est toutefois possible de masquer des offres ou des options en cours de campagne.
                </v-alert>
            </v-row>

            <v-row>
                <v-col class="d-flex" cols="9">
                    <v-select label="Bulletin d'adhésion" outlined :items="cadhConfigs" v-model="cadhConfigId"
                              @input="setCadhConfigId" item-value="id" item-text="name" :disabled="readOnly"
                              v-if="account.configurations.adhesionV3 !== null"
                              no-data-text="Vous n'avez pas de bulletin d'adhésion configuré">
                    </v-select>
                    <v-select label="Bulletin d'adhésion" outlined :items="cadhConfigs" v-model="cadhConfigId"
                              item-value="id" item-text="name" disabled v-else>
                    </v-select>
                </v-col>

                <v-col class="d-flex" cols="3">
                    <v-btn class="custom-button-primary mt-3" outlined @click="seeConfig"
                           :disabled="cadhConfigId === null">
                        <v-icon class="mr-2">remove_red_eye</v-icon>
                        Prévisualiser
                    </v-btn>
                </v-col>
            </v-row>
        </v-container>

        <div class="text-right mb-5 mt-5">
            <v-btn class="default-button" @click="setCurrentStep(4)">Passer à l'étape suivante</v-btn>
        </div>
    </div>
</template>

<script>
import { mapMutations, mapState } from "vuex"
import _ from "lodash"

export default {
    name: "ConfigurationChoice",
    props: ["readOnly"],
    data() {
        return {
            cadhConfigs: [],
        }
    },
    methods: {
        ...mapMutations("createCadh", ["setCurrentStep", "setCadhConfigId"]),
        getConfigs: _.debounce(function() {
            this.$http.get("adhesion/configs/" + this.account.id).then(res => {
                this.cadhConfigs = res.body.data.cadhConfigurations.filter(config =>
                  config.configured !== "Non configuré")

                if (this.cadhConfigs.length > 0 && this.account.configurations.adhesionV3 === null && !this.readOnly) {
                    this.setCadhConfigId(this.cadhConfigs[0].id)
                }
            })
        }),
        seeConfig() {
            let config = this.cadhConfigs.find(cadhConfig => cadhConfig.id === this.cadhConfigId)
            let url = window.location.origin + "/cadh-preview/" + config.token

            window.open(url)
        },
    },
    computed: {
        ...mapState("createCadh", ["currentStep", "cadhConfigId"]),
        ...mapState("account", ["account"]),
    },
    created() {
        this.getConfigs()
    },
}
</script>